import React from 'react';
import { useTable, useSortBy } from 'react-table';
import './style/pendingTransactions.scss';

const RefundTransactions = () => {
  const data = React.useMemo(
    () => [
      {
        id: 'TRC0001',
        product: 'Suit - Navy | K0012',
        date: '23/08/2024',
        orderStatus: 'Pending',
        paymentStatus: 'Paid',
        category: 'Suits',
        orderType: 'Finish Goods',
        total: 'Rp 280000',
        shipping: 'JNT Express',
        image: 'https://placehold.co/60x60/png',
      },
      {
        id: 'TRC0002',
        product: 'Vest - Navy | K0012',
        date: '23/08/2024',
        orderStatus: 'Pending',
        paymentStatus: 'Paid',
        category: 'Vests',
        orderType: 'Finish Goods',
        total: 'Rp 280000',
        shipping: 'JNT Express',
        image: 'https://placehold.co/60x60/png',
      },
      // Add more data as needed
    ],
    []
  );

  const columns = React.useMemo(
    () => [
      {
        Header: '',
        accessor: 'selection',
        Cell: () => (
          <input type="checkbox" className="row-checkbox" />
        ),
        width: 40,
      },
      {
        Header: 'Transaction ID',
        accessor: 'id',
      },
      {
        Header: 'Product Name',
        accessor: 'product',
        Cell: ({ row }) => (
          <div className="product-cell">
            <img src={row.original.image} alt="product" className="product-image" />
            <span>{row.original.product}</span>
          </div>
        ),
      },
      {
        Header: 'Transaction Date',
        accessor: 'date',
      },
      {
        Header: 'Order Status',
        accessor: 'orderStatus',
      },
      {
        Header: 'Payment Status',
        accessor: 'paymentStatus',
      },
      {
        Header: 'Category',
        accessor: 'category',
      },
      {
        Header: 'Order Type',
        accessor: 'orderType',
      },
      {
        Header: 'Total Transaction',
        accessor: 'total',
      },
      {
        Header: 'Shipping By',
        accessor: 'shipping',
      },
    ],
    []
  );

  const tableInstance = useTable({ columns, data }, useSortBy);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  return (
    <div className="pending-transactions">
      <div className="search-section">
        <input
          type="text"
          placeholder="Search transaction id or product name"
          className="search-bar"
        />
      </div>
      <div className="filters">
        <select>
          <option>All Category</option>
        </select>
        <select>
          <option>All Payment Status</option>
        </select>
        <select>
          <option>All Order Type</option>
        </select>
      </div>
      <div className="table-container">
        <table {...getTableProps()} className="transactions-table">
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.Header === '' ? (
                      <input type="checkbox" className="header-checkbox" />
                    ) : (
                      column.render('Header')
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RefundTransactions;
